import styled from 'styled-components';

const Wrapper = styled.section`
  border-radius: var(--border-radius);
  width: 100%;
  background: var(--background-secondary-color);
  padding: 3rem 2rem 4rem;

  h3 {
    margin-top: 0;
  }

  .form {
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    max-width: 100%;
    width: 100%;
  }

  .form-title {
    margin-bottom: 2rem;
  }

  .form-row {
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
  }

  .form-label {
    margin-bottom: 0.5rem;
    font-weight: bold;
  }

  .form-center {
    display: grid;
    row-gap: 1rem;
  }

  .form-textarea {
    padding: 10px;
    border: 1px solid var(--grey-500);
    border-radius: var(--borderRadius);
    width: 100%;
    font-size: 1rem;
    transition: all 0.3s ease;
    min-height: 100px;
    resize: vertical;
  }

  .btn-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 0.5rem;
  }

  .buildings-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 0.5rem;
  }

  .checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px;
  }

  .checkbox-group label {
    display: inline-flex;
    align-items: center;
    background: #fff;
    border: 1px solid #ccc;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease, transform 0.2s ease;
    min-width: 80px;
    justify-content: center;
  }

  .checkbox-group label:hover {
    background-color: #e6f7ff; 
    transform: scale(1.05); 
  }

  .checkbox-group label input {
    margin-right: 0.5rem;
  }

  /* רספונסיביות */
  @media (min-width: 992px) {
    .form-center {
      align-items: stretch;
      column-gap: 3rem;
      display: grid;
      row-gap: 2rem;
      grid-template-columns: 1fr 1fr;
      gap: 2rem;
    }

    .btn-container {
      margin-top: 0;
    }
  }

  @media (min-width: 1130px) {
    .form-center {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
`;

export default Wrapper;
